<script>
import {mapActions} from "vuex";
import InfiniteTraderLocationAutoComplete from "@/driver/components/InfiniteTraderLocationAutoComplete.vue";
import InfiniteRecycleDisposerAutoComplete from "@/driver/components/InfiniteRecycleDisposerAutoComplete.vue";
import ItemAutocomplete from "@/driver/components/ItemAutocomplete.vue";
import Confirm from "@/components/Confirm.vue";
import ChooseTraderModal from "@/driver/components/ChooseTraderModal.vue";
import ChooseRecycleDisposalPatternBotton from '@/driver/components/ChooseRecycleDisposalPatternBotton.vue'

export default {
  name: "MasterFlowForm",
  components: {
    ChooseTraderModal,
    Confirm,
    InfiniteTraderLocationAutoComplete,
    InfiniteRecycleDisposerAutoComplete,
    ItemAutocomplete,
    ChooseRecycleDisposalPatternBotton,
  },
  props: {
    targetId: {
      type: Number,
      default: null,
    },
    referenceOnly: {
      type: Boolean,
      default: false,
    }
  },
  data () {
    return {
      form: null,
      items: [],
      recycleDisposerDisposalMethods: [],
      headers: [
        { value: "level", text: "", width: "5%" },
        { value: "api_id", text: "API-ID", width: "4%", align: "center" },
        { value: "disposer", text: "処分業者\r\n処分事業場", width: "14%" },
        { value: "before_disposal_ratio", text: "処分割合", width: "7%" },
        { value: "disposal_method", text: "処分方法", width: "13%" },
        { value: "after_disposal_ratio", text: "処理後割合", width: "7%" },
        { value: "recycle_disposed_item", text: "処理後物の種類", width: "14%" },
        { value: "final_disposal", text: "最終処分", width: "11%" },
        { value: "add_next_step", text: "後工程", width: "11%" },
        { value: "comment", text: "備考", width: "9%", editable: true },
        { value: "edit_request_action", text: "", width: "5%", align: "end" },
      ],
      enableNextStepModal: false,
      enableConfirmModal: false,
      enableTraderModal: false,
      latestRecycleDisposerDisposalMethodId: null,
    }
  },
  watch: {},
  computed: {
    /**
     * 削除を除くリストを再生成
     * @return {*[]}
     */
    active_items () {
      if (this.form) {
        return this.form.recycle_disposal_flow_details.filter(method => !method._destroy);
      } else {
        return [];
      }
    },
    editableMode () {
      return !!this.targetId;
    },
    pageTitle () {
      if (this.referenceOnly) {
        return "詳細"
      } else if (this.targetId) {
        return "編集"
      } else {
        return "登録"
      }
    },
    recyclePatternDialogCondition () {
      if (!this.form) {
        return {
          disposer_id: null,
          disposer_location_id: null,
          disposer_location_code: null,
          item_id: null,
        }
      }
      return {
        disposer_id: this.form.disposer_id,
        disposer_location_id: this.form.disposer_location_id,
        disposer_location_code: this.form.disposer_location_code,
        item_id: this.form.item_ids,
      }
    },
  },
  created () {
    if (this.editableMode) {
      this.fetchEdit( { id: this.targetId } ).then((content) => {
        this.form = content;
        this.latestRecycleDisposerDisposalMethodId = this.form.recycle_disposer_disposal_method_id;
        this.reloadItemList();
      })
    } else {
      this.fetchNew().then((content) => {
        this.form = content;
        this.reloadItemList();
      })
    }

  },
  methods: {

    /**
     * 処理フロー
     */
    ...mapActions("DriverMasterRecycleDisposalFlow", {
      fetchNew: "new",
      fetchEdit: "edit",
      create: "create",
      update: "update",
      destroy: "destroy",
    }),

    /**
     * 処分場処理方法
     */
    ...mapActions("DriverMasterSearchRecycleDisposerDisposalMethod", {
      fetchRecycleDisposerDisposalMethods: "index",
    }),

    /**
     * JWNET取扱品目
     */
    ...mapActions("DriverMasterSearchItem", {
      fetchItems: "fetchWholeItems",
    }),

    /**
     * 処分場処理方法の処分前廃棄物種類
     */
    ...mapActions("DriverMasterSearchRecycleDisposerDisposalMethodItem", {
      fetchRecycleDisposerDisposalMethodItem: "show",
    }),

    /**
     * 処分事業者選択ボタン クリックイベント
     */
    openChooseTraderModalClickEvent () {
      this.enableTraderModal = true;
    },

    /**
     * 登録ボタン クリックイベント
     */
    registerButtonClickEvent () {
      this.$refs.validationObserver.validateWithInfo().then(({ isValid, errors }) => {
        if (isValid) {
          this.register();
        }
      })
    },

    /**
     * 閉じるボタン クリックイベント
     */
    cancelButtonClickEvent () {
      this.$router.push({ name: 'DriverMasterRecycleDisposalPatterns' });
    },

    /**
     * 削除ボタン クリックイベント
     */
    deleteButtonClickEvent () {
      this.$refs.confirm.showDeleteConfirm().then((confirm) => {
        this.$refs.confirm.close()
        if (confirm) {
          this.destroy({ id: this.targetId }).then(() => {
            this.$router.push({ name: 'DriverMasterRecycleDisposalPatterns' });
          });
        }
      })
    },

    /**
     * 処分場処理方法 チェンジイベント
     */
    recycleDisposalMethodChangeEvent () {
      if (
        this.latestRecycleDisposerDisposalMethodId !== null &&
        this.latestRecycleDisposerDisposalMethodId !== this.form.recycle_disposer_disposal_method_id &&
        this.form.recycle_disposal_flow_details.length > 0
      ) {
        this.enableConfirmModal = true;
      } else {
        this.latestRecycleDisposerDisposalMethodId = this.form.recycle_disposer_disposal_method_id;
        this.loadRecycleDisposerDisposalMethodItemId();
        this.reloadItemList();
      }
    },

    /**
     * JWNET取扱品目 チェンジイベント
     */
    itemChangeEvent () {
      this.loadRecycleDisposerDisposalMethods();
    },

    /**
     * 処分事業者選択モーダル コールバック
     * @param item { Object } 処分事業者情報
     */
    chooseTraderCallback (item) {
      if (this.form.disposer_id !== item.id) {
        this.form.disposer_id = item.id;
        this.clearMembers();
      }
      this.closeModal();
    },

    /**
     * 処分業者 コールバック
     * @param object { Object, null } 処分事業者情報
     */
    disposerChangedCallback (object) {

      if (!object) {
        this.form.disposer_id = null;
        this.form.disposer_location_id = null;
        this.form.disposer_location_code = null;
        this.clearMembers();
        return;
      }
      this.form.disposer_id = object.id;
      this.loadRecycleDisposerDisposalMethods();
    },

    /**
     * 処分事業場 コールバック
     * @param object { Object }
     * @property object.id
     * @property object.code
     * @property object.parent_id
     * @property object.parent_type
     */
    disposerLocationChangeCallback (object) {
      if (!object) {
        this.form.disposer_location_id = null;
        this.form.disposer_location_code = null;
        this.clearMembers();
        return;
      }
      this.form.disposer_location_id = object.id;
      this.form.disposer_location_code = object.code;
      if (this.form.disposer_id !== object.parent_id) {
        this.form.disposer_id = object.parent_id;
      }
      this.loadRecycleDisposerDisposalMethods();
    },

    /**
     * 処理フロー変更確認モーダル コールバック
     */
    changeDetailIdNegativeCallback () {
      this.form.recycle_disposer_disposal_method_id = this.latestRecycleDisposerDisposalMethodId;
      this.loadRecycleDisposerDisposalMethods();
      this.reloadItemList();
      this.enableConfirmModal = false;
    },

    /**
     * 処理フロー変更確認モーダル コールバック
     */
    changeDetailIdPositiveCallback () {
      if (this.form.recycle_disposer_disposal_method_id != null) {
        this.latestRecycleDisposerDisposalMethodId = this.form.recycle_disposer_disposal_method_id;
        this.loadRecycleDisposerDisposalMethodItemId();
      } else {
        this.form.recycle_disposal_flow_details = [];
        this.form.recycle_disposer_disposal_method_id = null;
        this.form.item_ids = []
        this.latestRecycleDisposerDisposalMethodId = null;
        this.loadRecycleDisposerDisposalMethods()
      }
      this.reloadItemList();
      this.enableConfirmModal = false;
    },

    /**
     * 処分場処理方法検索モーダルの選択結果を反映する
     * @param payload {{ pattern: { id: number, type: string } }}
     */
    choseRecycleDisposalPatternCallback (payload) {
      const pattern = payload?.pattern
      if (!pattern || pattern.type !== 'methods') {
        return
      }

      this.$refs.recycleDisposerDisposalMethod.isMenuActive = false;

      const selectedId = pattern.id
      if (!this.recycleDisposerDisposalMethods.some(method => method.value === selectedId)) {
        this.recycleDisposerDisposalMethods = [
          ...this.recycleDisposerDisposalMethods,
          {
            value: selectedId,
            text: pattern.pattern_name,
            pattern_name: pattern.pattern_name,
          }
        ]
      }

      this.$set(this.form, 'recycle_disposer_disposal_method_id', selectedId)
      this.latestRecycleDisposerDisposalMethodId = selectedId

      this.loadRecycleDisposerDisposalMethodItemId();
      this.reloadItemList();

      if (Array.isArray(payload?.pattern_details)) {
        this.$set(
          this.form,
          'recycle_disposal_flow_details',
          payload.pattern_details.map(detail => ({ ...detail }))
        )
      }
    },

    /**
     * リストの洗い替え
     * @param items { Array }
     */
    replaceResultList (items) {
      this.form.recycle_disposal_flow_details = items;
    },

    closeModal () {
      this.enableTraderModal = false;
    },

    /**
     * JWNET取扱品目の展開
     */
    reloadItemList () {
      this.fetchItems(this.latestRecycleDisposerDisposalMethodId).then((content) => {
        this.items = content.items;
      });
    },

    /**
     * 登録処理
     */
    register () {

      let _form = {
        code: this.form.code,
        name: this.form.name,
        disposer_id: this.form.disposer_id,
        disposer_location_code: this.form.disposer_location_code,
        sort_priority: this.form.sort_priority,
        invisible: this.form.invisible,
        item_ids: this.form.item_ids,
        recycle_disposal_flow_details_attributes: [],
      };

      this.form.recycle_disposal_flow_details.forEach((item, _) => {

        _form.recycle_disposal_flow_details_attributes.push({
          id: item.id,
          level: item.level,
          recycle_disposer_disposal_method_id: item.recycle_disposer_disposal_method_id,
          recycle_disposer_disposal_method_detail_id: item.recycle_disposer_disposal_method_detail_id,
          request_ratio: item.request_ratio,
          before_disposal_ratio: item.before_disposal_ratio,
          after_disposal_ratio: item.after_disposal_ratio,
          comment: item.comment,
          sort_priority: item.sort_priority,
        });

      })

      const params = {
        recycle_disposal_flow: _form
      }

      if (this.editableMode) {
        this.update({ id: this.targetId, params: params }).then(() => {
          this.$router.push({ name: 'DriverMasterRecycleDisposalPatterns' });
        })
      } else {
        this.create({ params: params }).then(() => {
          this.$router.push({ name: 'DriverMasterRecycleDisposalPatterns' });
        });
      }
    },

    /**
     * 処分場処理方法に紐付く処理前廃棄物のIDを取得.
     *
     */
    loadRecycleDisposerDisposalMethodItemId () {
      this.fetchRecycleDisposerDisposalMethodItem(this.form.recycle_disposer_disposal_method_id).then((content) => {
        this.form.item_ids = content.item_ids;
      })
    },

    /**
     * 処分場処理方法リストの展開
     * ・処分事業者(id, type)/処分事業場が揃っていること.
     */
    loadRecycleDisposerDisposalMethods () {

      if (this.form.disposer_id !== null && this.form.disposer_location_code !== null) {

        const condition = {
          item_id: this.form.item_ids,
          disposer_id: this.form.disposer_id,
          disposer_location_code: this.form.disposer_location_code,
          final_disposal: false
        }

        this.fetchRecycleDisposerDisposalMethods({ ...condition }).then((content) => {
          this.recycleDisposerDisposalMethods = content.recycle_disposer_disposal_methods;
        });

      } else {
        this.recycleDisposerDisposalMethods = [];
        this.form.recycle_disposer_disposal_method_id = null;
        this.form.recycle_disposal_flow_details = []
      }

    },

    /**
     * メンバークリア処理
     */
    clearMembers() {
      this.recycleDisposerDisposalMethods = [];
      this.form.recycle_disposal_flow_details = [];
      this.form.recycle_disposer_disposal_method_id = null;
      this.latestRecycleDisposerDisposalMethodId = null;
    },

  }
}
</script>

<template>
  <div>
    <validation-observer
      ref="validationObserver"
    >
      <v-card flat rounded>

        <v-toolbar flat>
          <v-toolbar-title>処理フロー{{ pageTitle }}</v-toolbar-title>
        </v-toolbar>

        <v-card-text v-if="form">

          <!-- コード, 非表示にする -->
          <v-row>
            <v-col cols="12" md="4">
              <validation-provider
                v-slot="{ errors }"
                name="コード"
                rules="required|alpha_num_only|max:10"
                class="requiredMark"
              >
                <v-text-field
                  v-model="form.code"
                  :disabled="referenceOnly"
                  :error-messages="errors"
                  dense
                  outlined
                  hide-details="auto"
                  clearable
                  persistent-placeholder
                  placeholder="例）F001"
                >
                  <template v-slot:label>
                    <span>コード</span>
                    <span class="ml-1">
                      ({{ form.code?.length || 0 }} / 10)
                    </span>
                  </template>
                </v-text-field>
              </validation-provider>
            </v-col>
            <v-col
              cols="12"
              md="8"
            >
              <v-checkbox
                v-model="form.invisible"
                :disabled="referenceOnly"
                label="非表示にする"
                hide-details="auto"
                persistent-placeholder
                class="d-inline-block"
                :class="{ 'mt-2': referenceOnly }"
              />
              <div
                v-if="form.recent_codes.length > 0 && !referenceOnly"
              >
                最近使用したコード:&nbsp;<strong>{{ form.recent_codes.join(', ') }}</strong>
              </div>
            </v-col>
          </v-row>
          <!-- /コード, 非表示にする -->

          <!-- パターン名 -->
          <v-row>
            <v-col cols="12" md="4">
              <validation-provider
                v-slot="{ errors }"
                name="パターン名"
                rules="required|max:60"
                class="requiredMark"
              >
                <v-text-field
                  v-model="form.name"
                  :disabled="referenceOnly"
                  :error-messages="errors"
                  dense
                  outlined
                  hide-details="auto"
                  clearable
                  persistent-placeholder
                >
                  <template v-slot:label>
                    <span>パターン名</span>
                    <span class="ml-1">
                      ({{ form.name?.length || 0 }} / 60)
                    </span>
                  </template>
                </v-text-field>
              </validation-provider>
            </v-col>
          </v-row>
          <!-- /パターン名 -->

          <!-- 処分事業者, 処分事業場 -->
          <v-row>
            <v-col cols="12">
              <h4 class="primary--text">処分事業者を選択</h4>
            </v-col>
            <v-col cols="12" md="4">
              <infinite-recycle-disposer-auto-complete
                :disposer-id="form.disposer_id"
                :location-id="form.disposer_location_id"
                :disabled="referenceOnly || editableMode"
                label="処分事業者"
                with-none-reporting
                without-invisible
                with-none-subscribe
                required
                @update:values="disposerChangedCallback"
              >
                <template v-slot:append-outer>
                  <v-btn
                    :disabled="referenceOnly || editableMode"
                    color="primary"
                    @click="openChooseTraderModalClickEvent"
                  >
                    選択
                  </v-btn>
                </template>
                <template v-slot:item="{ item }">
                  <v-chip
                    color="#e0ffff"
                    drak
                    label
                    small
                  >
                    {{ item.type === 'Trader::FinalDisposer' ? item.code : item.subscriber_number }}
                  </v-chip>&nbsp;
                  {{ item.text }}&nbsp;
                </template>
              </infinite-recycle-disposer-auto-complete>
            </v-col>
            <v-col cols="12" md="4" >
              <infinite-trader-location-auto-complete
                :trader-id="form.disposer_id"
                :location-id="form.disposer_location_id"
                :disabled="referenceOnly || editableMode"
                chose-one
                label="処分事業場"
                required
                search-type="trader"
                with-final-disposer
                without-invisible
                permit-number-registered-only
                @update:values="disposerLocationChangeCallback"
              >
                <template v-slot:item="{ item }">
                  <v-chip
                    color="#e0ffff"
                    drak
                    label
                    small
                  >
                    {{ item.code }}
                  </v-chip>&nbsp;
                  {{ item.text }}&nbsp;
                </template>
              </infinite-trader-location-auto-complete>
            </v-col>
          </v-row>
          <!-- /処分事業者, 処分事業場 -->

          <v-row>
            <v-col cols="12">
              <h4 class="primary--text">処理フロー</h4>
            </v-col>
          </v-row>
          <v-sheet
            outlined
            rounded
          >
            <!-- 処分場処理方法 -->
            <v-row
              class="mt-3"
            >
              <v-col cols="12" md="4">
                <validation-provider
                  v-slot="{ errors }"
                  name="処分場処理方法"
                  class="requiredMark"
                >
                  <v-autocomplete
                    ref="recycleDisposerDisposalMethod"
                    v-model="form.recycle_disposer_disposal_method_id"
                    :disabled="referenceOnly || editableMode"
                    :error-messages="errors"
                    :items="recycleDisposerDisposalMethods"
                    dense
                    hide-details="auto"
                    clearable
                    label="処分場処理方法"
                    outlined
                    persistent-placeholder
                    @change="recycleDisposalMethodChangeEvent"
                  >
                    <!-- 修正ポイント: append-outer スロット内にボタンコンポーネントを配置 -->
                    <template v-slot:append-outer>
                      <choose-recycle-disposal-pattern-botton
                        :fixed-condition.sync="recyclePatternDialogCondition"
                        :disabled="referenceOnly || editableMode"
                        button-caption="選択"
                        only-method
                        :final-disposal=false
                        required-location
                        @choseRecycleDisposalPatternCallback="choseRecycleDisposalPatternCallback"
                      />
                    </template>

                    <template v-slot:item="scope">
                      <div class="d-flex align-center py-1" style="width: 100%;">
                        <div class="flex-shrink-0 mr-3">
                          <v-chip
                            small
                            color="primary"
                          >
                            処分場処理方法
                          </v-chip>
                        </div>
                        <div style="flex: 1; word-break: break-word; min-width: 0;">
                          <small>
                            {{ scope.item.pattern_name }}
                            <span v-if="scope.item.not_all_final_disposal === false">（最終）</span>
                          </small>
                        </div>
                      </div>
                    </template>
                  </v-autocomplete>
                </validation-provider>

              </v-col>
            </v-row>
            <!-- /処分場処理方法 -->

            <v-row v-if="form.recycle_disposal_flow_details">
              <v-col>
                <validation-provider
                  v-slot="{ errors: detailErrors }"
                  name="リスト"
                  :rules="{
                    pMLength: { targetList: active_items },
                    pMIsIncludeItem: { targetList: active_items, targetItemIds: form.item_ids },
                    pMExceptFinalDisposal: { targetList: active_items },
                  }"
                >
                  <div class="hidden">
                    <v-input
                      v-model="form"
                      :error-messages="detailErrors"
                      dense
                      outlined
                      readonly
                      hide-details="auto"
                    >
                      <template v-slot:message>
                        <div class="ml-2">
                          <p v-for="(message, index) in detailErrors" :key="index">{{ message }}</p>
                        </div>
                      </template>
                    </v-input>
                  </div>
                  <recycle-step-table
                    :headers="headers"
                    :result-list.sync="form.recycle_disposal_flow_details"
                    :has-error="detailErrors.length > 0"
                    :editable-mode="editableMode"
                    :reference-only="referenceOnly"
                    :disposer-id="form.disposer_id"
                    :disposer-location-id="form.disposer_location_id"
                    :disposer-location-code="form.disposer_location_code"
                    :item-ids="form.item_ids"
                    :pattern-id="latestRecycleDisposerDisposalMethodId"
                    call-source="masterFlow"
                    pattern-type="methods"
                    @replace:list="replaceResultList"
                  />
                </validation-provider>
              </v-col>
            </v-row>
          </v-sheet>

          <!-- JWNET取扱品目, 表示順 -->
          <v-row>
            <v-col cols="12">
              <h4 class="primary--text">処分前廃棄物種類</h4>
            </v-col>
            <v-col cols="12" md="8">
              <item-autocomplete
                v-model="form.item_ids"
                :clearable="!items.some(v => v.disabled)"
                :disabled="referenceOnly"
                :items="items"
                label="取扱品目"
                multiple
                chips
                small-chips
                deletable-chips
                dense
                hide-details="auto"
                outlined
                persistent-placeholder
                classes="target-items-select"
                @change="itemChangeEvent"
              />
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="12" md="4">
              <validation-provider
                v-slot="{ errors }"
                :rules="{ numeric: true, min_value: 0, max_value: 99999 }"
                name="表示順"
              >
                <v-text-field
                  v-model="form.sort_priority"
                  :disabled="referenceOnly"
                  :error-messages="errors"
                  :show-size="1000"
                  dense
                  label="表示順"
                  outlined
                  hide-details="auto"
                  persistent-placeholder
                  reverse
                  type="number"
                  @keydown.69.prevent
                />
              </validation-provider>
            </v-col>
          </v-row>
          <!-- /JWNET取扱品目, 表示順 -->

        </v-card-text>

        <v-divider />

        <v-card-actions>
          <v-btn
            v-if="referenceOnly"
            :disabled="!form"
            color="error"
            @click="deleteButtonClickEvent"
          >
            削除
          </v-btn>
          <v-spacer />
          <v-btn
            @click="cancelButtonClickEvent"
          >
            閉じる
          </v-btn>
          <v-btn
            v-if="!referenceOnly"
            :disabled="!form"
            color="primary"
            @click="registerButtonClickEvent"
          >
            登録
          </v-btn>
        </v-card-actions>

      </v-card>
    </validation-observer>
    <v-dialog
      v-model="enableConfirmModal"
      width="400"
    >
      <v-card>
        <v-toolbar color="info" dark flat>
          <v-toolbar-title>確認</v-toolbar-title>
        </v-toolbar>
        <v-divider />
        <v-card-text>
          <h4 class="py-2">リストが破棄されますがよろしいですか？</h4>
        </v-card-text>
        <v-divider />
        <v-card-actions>
          <v-spacer />
          <v-btn @click="changeDetailIdNegativeCallback">キャンセル</v-btn>
          <v-btn color="info" @click="changeDetailIdPositiveCallback">変更する</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <confirm ref="confirm" />
    <choose-trader-modal
      :enable="enableTraderModal"
      search-type="trader"
      without-invisible
      include-final-disposer
      permit-number-registered-only
      @close="closeModal"
      @selected="chooseTraderCallback"
    />
  </div>
</template>

<style lang="scss">

.select-actions {
  margin-left: 8px;
  padding-top: 4px;
}

</style>
